import axios from 'axios';

const BASE_URL = 'https://1001albumsgenerator.com/api/v1';
const BASE_INTERVAL = 20000; // 20 seconds
const MAX_RETRIES = 3;

class RateLimitedAPI {
  constructor() {
    this.lastCallTime = 0;
    this.retryCount = 0;
  }

  async call(endpoint) {
    const now = Date.now();
    const timeSinceLastCall = now - this.lastCallTime;
    const currentInterval = BASE_INTERVAL * Math.pow(2, this.retryCount);

    if (timeSinceLastCall < currentInterval) {
      await new Promise(resolve => 
        setTimeout(resolve, currentInterval - timeSinceLastCall)
      );
    }

    const fullUrl = `${BASE_URL}${endpoint}`;
    console.log('Making API call to:', fullUrl);

    try {
      this.lastCallTime = Date.now();
      const response = await axios.get(fullUrl);
      console.log('API call successful:', endpoint);
      this.retryCount = 0;
      return response.data;
    } catch (error) {
      console.error('API call failed:', {
        endpoint,
        status: error.response?.status,
        statusText: error.response?.statusText,
        data: error.response?.data
      });

      if (error.response?.status === 429 && this.retryCount < MAX_RETRIES) {
        this.retryCount++;
        console.log(`Rate limited. Retry attempt ${this.retryCount}`);
        return this.call(endpoint);
      }

      if (error.response?.status === 404) {
        console.error('User/project not found:', endpoint);
        throw new Error(`User/project not found. Please check the user ID in settings.`);
      }

      throw error;
    }
  }
}

const api = new RateLimitedAPI();

const getCurrentUserId = () => {
  const storageValue = localStorage.getItem('albumGeneratorUser');
  console.log('Raw storage value:', storageValue);
  
  if (!storageValue || storageValue.trim() === '') {
    console.log('Using default user ID: david-carroll');
    return 'david-carroll';
  }
  
  const cleanUserId = storageValue.trim();
  console.log('Using user ID:', cleanUserId);
  return cleanUserId;
};

// Single fetch function that gets both current album and history
export const fetchProjectData = async () => {
  const userId = getCurrentUserId();
  console.log('Fetching project data for user:', userId);
  const data = await api.call(`/projects/${userId}`);
  return {
    currentAlbum: data.currentAlbum || null,
    history: data.history || []
  };
};

export const fetchWikiContent = async (url) => {
  if (!url) return '';
  
  try {
    const title = url.split('/wiki/')[1];
    const apiUrl = `https://en.wikipedia.org/w/api.php?action=query&format=json&prop=extracts&exintro=true&redirects=1&titles=${title}&origin=*`;
    
    const response = await axios.get(apiUrl);
    const pages = response.data.query.pages;
    const pageId = Object.keys(pages)[0];
    const extract = pages[pageId].extract;
    
    if (!extract) return '';

    const cleanExtract = extract.replace(/<\/?[^>]+(>|$)/g, "");
    const paragraphs = cleanExtract.split('\n').filter(p => p.trim() !== '');
    return paragraphs.slice(0, 2).join('\n\n');
  } catch (error) {
    console.error('Error fetching Wikipedia content:', error);
    return '';
  }
};